<template>
  <div
    class="corp-header"
    data-qa="corporate-header"
  >
    <div
      v-if="corporate?.logoFile"
      class="corp-logo"
    >
      <img
        :src="corporate.logoFile"
        alt="logo"
      />
    </div>
    <div
      v-else-if="corporate?.title"
      class="kds-typography-display-small"
    >
      {{ corporate.title }}
    </div>
  </div>
</template>

<script setup>
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import { computed } from 'vue'
import useLandingPageStore from '@shared/stores/useLandingPageStore.js'

const corporateStore = useCorporateStore()
const landingPageStore = useLandingPageStore()

const props = defineProps({
  corporate: {
    type: Object,
    default: null,
  },
})

const corporate = computed(() => {
  const baseCorporate = props.corporate || corporateStore.corporate || {}
  const landingPage = landingPageStore.landingPage

  return {
    title: landingPage?.displayTitle || baseCorporate.title,
    logoFile: landingPage?.logo || baseCorporate.logoFile,
  }
})
</script>

<style lang="scss" scoped>
.corp-header {
  .corp-logo {
    img {
      max-height: 64px;
      max-width: 200px;

      @include media-up(md) {
        max-height: 80px;
        max-width: 272px;
      }
    }
  }
}
</style>
